





























































import * as R from 'ramda';
import Vue from 'vue';

import { Task } from '@/core/entity';

import { getTask, Category, Entry, Task as GqlTask } from './graphql';

interface CategoryOption {
  id: string;
  name: string;
}

interface Option {
  key: string;
  title: string;
  department: string;
}

export default Vue.extend({
  apollo: {
    task: {
      query: getTask,
      fetchPolicy: 'no-cache',
      variables() {
        const taskId = this.$route.params.task_id;
        return { id: taskId };
      },
    },
  },

  data() {
    return {
      loading: false,
      target: [] as string[],
      task: null as GqlTask | null,
    };
  },

  computed: {
    categories(): CategoryOption[] {
      if (this.task === null) {
        return [];
      }

      return R.pipe(
        R.map<Entry, CategoryOption>((e) => {
          const categories = e.product.category.canonicalName.split(' / ');
          return {
            id: `${categories[0]} / ${categories[1]}`,
            name: categories[1],
          };
        }),
        R.uniqBy((c) => c.id),
        R.sortWith([R.ascend(R.prop('name'))]),
      )(this.task.entries);
    },

    products(): Option[] {
      if (this.task === null) {
        return [];
      }

      return R.pipe(
        R.map<Entry, Option>((e) => {
          const categories = e.product.category.canonicalName.split(' / ');
          const department = categories[1];

          return {
            key: e.id,
            title: e.product.name,
            department,
          };
        }),
        R.sortWith([R.ascend(R.prop('title'))]),
      )(this.task.entries);
    },

    taskId(): string {
      return this.$route.params.task_id;
    },
  },

  methods: {
    filterOption(inputValue: string, option: Option) {
      const product = option.title.toLowerCase();
      const category = option.department.toLowerCase();
      return (
        category.indexOf(inputValue) !== -1 ||
        product.indexOf(inputValue) !== -1
      );
    },

    handleChange(targetKeys: any, direction: any, moveKeys: any) {
      this.target = targetKeys;
    },

    handleSplit() {
      this.$coreApp.task.split(
        this.taskId,
        this.target,
        this.presenter('New task created.', 'Unable to split task.'),
      );
    },

    presenter(success: string, failure: string) {
      return (err: Error | null, result: Task | null, loading: boolean) => {
        this.loading = loading;
        if (err) {
          this.$message.error(`${failure} ${err.message}`);
        } else if (result !== null) {
          this.$message.success(success);
          this.$router.push({ name: 'task.list' });
        }
      };
    },

    renderItem(opt: Option) {
      const h = this.$createElement;
      const product = opt.title;
      const department = opt.department;

      const customLabel = h(
        'span',
        {
          class: 'item',
        },
        [h('span', { class: 'tag' }, department), h('span', product)],
      );

      return {
        label: customLabel, // for displayed item
        value: product, // for title and filter matching
      };
    },
  },
});
